// Live Healthillie Standard ingredients data — generated from internal Standard doc
window.LH_INGREDIENTS = [
  {
    "name": "Acesulfame-Potassium",
    "aliases": [
      "ACE-K",
      "Acesulfame K",
      "Acesulfame Potassium"
    ],
    "status": "banned",
    "description": "Acesulfame-K is a synthetic sweetener often used alongside other sweeteners to intensify sweetness. Evidence suggests it may influence insulin response and glucose signaling independent of caloric intake and may contribute to microbiome disruption with habitual use. While considered safe by regulatory standards at typical exposure levels, it offers no health benefit and may complicate metabolic signaling when consumed regularly.",
    "foundIn": [
      "Supplements (electrolytes, protein powders, drink mixes)",
      "Personal care (toothpaste)"
    ]
  },
  {
    "name": "Aloe Barbadensis Leaf / Sorbus Aucuparia Fruit Ferment Filtrate",
    "aliases": [
      "Aloe Ferment",
      "Sorbus Ferment Filtrate"
    ],
    "status": "allowed",
    "description": "A multifunctional ferment system used for gentle preservation and skin conditioning. Helps support microbiome balance without harsh preservatives.",
    "foundIn": [
      "Skincare"
    ]
  },
  {
    "name": "Aluminum Compounds",
    "aliases": [
      "Aluminum Powder",
      "Aluminum Starch Octenylsuccinate"
    ],
    "status": "banned",
    "description": "Certain aluminum forms can bioaccumulate and are linked to oxidative stress and neurotoxicity. Aluminum powder, in particular, carries inhalation risk and is unnecessary in clean formulations.",
    "foundIn": [
      "Skincare (makeup, powders, primers)",
      "Personal care (deodorants, dry shampoos)"
    ]
  },
  {
    "name": "Alcohol Denat.",
    "aliases": [
      "Denatured Alcohol",
      "Alcohol Denatured"
    ],
    "status": "banned",
    "description": "Used to improve texture and speed drying, but alcohol denat. can disrupt the skin barrier, increase transepidermal water loss, exacerbate inflammation, and worsen acne, rosacea, and sensitivity over time. It may also increase penetration of other unwanted chemicals.",
    "foundIn": [
      "Skincare (toners, SPF, acne products)",
      "Personal care (hair sprays, deodorants)",
      "Perfume"
    ]
  },
  {
    "name": "Arundinaria Gigantea (Bamboo) Ferment Filtrate",
    "aliases": [
      "Bamboo Ferment Filtrate"
    ],
    "status": "allowed",
    "description": "A fermented bamboo extract rich in silica and bioavailable minerals that support skin resilience and hydration. Fermentation enhances absorption and reduces irritation potential.",
    "foundIn": [
      "Skincare"
    ]
  },
  {
    "name": "Ascorbic Acid",
    "aliases": [
      "Vitamin C",
      "L-Ascorbic Acid"
    ],
    "status": "conditional",
    "description": "A bioactive form of vitamin C used for antioxidant support, collagen synthesis, and skin brightening.",
    "nuance": "Ascorbic acid is effective but unstable and formulation-dependent. We allow it when properly stabilized and formulated to maintain efficacy without excessive irritation.",
    "foundIn": [
      "Skincare",
      "Supplements"
    ]
  },
  {
    "name": "Aspartame",
    "aliases": [],
    "status": "banned",
    "description": "Aspartame is a synthetic, high-intensity sweetener that provides sweetness without nutritional value. Research suggests it may alter gut microbiome balance, interfere with glucose regulation, and disrupt appetite and satiety signaling in some individuals. Sensitivity reactions such as headaches or GI discomfort have also been reported.",
    "foundIn": [
      "Supplements (gummies, flavored powders, drink mixes)",
      "Personal care (toothpaste, mouth rinses)"
    ]
  },
  {
    "name": "Aspartic Acid",
    "aliases": [],
    "status": "allowed",
    "description": "A naturally occurring amino acid used in topical formulations to support skin conditioning and hydration.",
    "foundIn": [
      "Skincare"
    ]
  },
  {
    "name": "Artificial Colors + Dyes",
    "aliases": [
      "FD&C Colors",
      "D&C Colors",
      "Lakes",
      "Food Dyes"
    ],
    "status": "banned",
    "description": "Petroleum-derived colors that may trigger hyperactivity in children and are linked to behavioral, gut, oxidative stress, and endocrine concerns.",
    "foundIn": [
      "Supplements (gummies, flavored powders, capsules)",
      "Skincare (lotions, serums, cosmetics)",
      "Personal care (toothpaste, soaps)"
    ]
  },
  {
    "name": "Artificial Flavors",
    "aliases": [],
    "status": "banned",
    "description": "Can contain undisclosed solvents, carriers, emulsifiers, preservatives, and synthetic aroma chemicals with no functional benefit.",
    "foundIn": [
      "Supplements (powders, gummies, liquids)",
      "Personal care (toothpaste, lip products)"
    ]
  },
  {
    "name": "Bakuchiol",
    "aliases": [],
    "status": "allowed",
    "description": "A plant-derived compound with retinol-like benefits, without the irritation or photosensitivity commonly associated with retinoids.",
    "foundIn": [
      "Skincare"
    ]
  },
  {
    "name": "Behentrimonium Methosulfate",
    "aliases": [
      "BTMS"
    ],
    "status": "allowed",
    "description": "A conditioning agent derived from rapeseed oil fatty acids, commonly used in hair and skin care to improve softness, detangling, and manageability. Despite the name, it is not a sulfate cleanser — it is a gentle, rinse-off conditioning compound.",
    "nuance": "The term \"methosulfate\" refers to the molecule's structure, not to harsh sulfates like SLS or SLES. BTMS is widely recognized as low-irritation, non-drying, and biodegradable, and is used at low concentrations for conditioning rather than cleansing.",
    "foundIn": [
      "Personal care (hair conditioners, masks, detanglers)",
      "Skincare (emulsions, creams)"
    ]
  },
  {
    "name": "Beef Tallow",
    "aliases": [
      "Tallow"
    ],
    "status": "allowed",
    "description": "A rendered animal fat rich in fatty acids that closely resemble those found in human skin. Supports barrier function and provides occlusive moisture when properly purified and formulated.",
    "foundIn": [
      "Skincare",
      "Personal care"
    ]
  },
  {
    "name": "BHA / BHT",
    "aliases": [
      "Butylated Hydroxyanisole",
      "Butylated Hydroxytoluene"
    ],
    "status": "banned",
    "description": "Synthetic preservatives linked to endocrine disruption, immune dysfunction, and possible carcinogenicity.",
    "foundIn": [
      "Skincare",
      "Personal care",
      "Cleaning products"
    ]
  },
  {
    "name": "Butylparaben",
    "aliases": [],
    "status": "banned",
    "description": "One of the most potent parabens in terms of estrogenic activity. Butylparaben has been linked to endocrine disruption, reproductive toxicity, and altered hormone signaling, and has been detected in human tissue.",
    "foundIn": [
      "Skincare",
      "Personal care",
      "Cleaning products"
    ]
  },
  {
    "name": "Butyl Methoxydibenzoylmethane",
    "aliases": [
      "Avobenzone"
    ],
    "status": "banned",
    "description": "A chemical UV filter commonly used in sunscreens. Avobenzone has been shown to exhibit endocrine-disrupting activity, can act as an obesogen, and is known to degrade when exposed to sunlight, forming reactive byproducts unless stabilized with additional chemicals. It is systemically absorbed and detectable in human blood after topical use.",
    "foundIn": [
      "Skincare (chemical sunscreens, SPF moisturizers)",
      "Personal care (lip balms with SPF)"
    ]
  },
  {
    "name": "Caprylic / Capric Triglyceride",
    "aliases": [],
    "status": "allowed",
    "description": "A stable, skin-compatible emollient derived from coconut or palm that improves texture and prevents moisture loss.",
    "foundIn": [
      "Skincare",
      "Personal care"
    ]
  },
  {
    "name": "Capryloyl Glycerin / Sebacic Acid Copolymer",
    "aliases": [],
    "status": "allowed",
    "description": "A biodegradable polymer used for texture enhancement and long-wear performance without microplastics.",
    "foundIn": [
      "Skincare",
      "Personal care"
    ]
  },
  {
    "name": "Castile Soap",
    "aliases": [],
    "status": "allowed",
    "description": "A traditional soap made from saponified vegetable oils, free from synthetic detergents. Castile soap has a naturally higher pH and can be stripping for sensitive or compromised skin if overused.",
    "foundIn": [
      "Personal care",
      "Cleaning products"
    ]
  },
  {
    "name": "Citric Acid",
    "aliases": [],
    "status": "conditional",
    "description": "Citric acid is a naturally occurring compound found in citrus fruits and used to stabilize pH. The concern around \"mold-derived citric acid\" is often misunderstood. Fermentation does not equal contamination.",
    "nuance": "We require non-GMO fermentation sources and mold testing. Citric acid itself is not a mold toxin.",
    "statusNote": "Allowed when non-GMO",
    "foundIn": [
      "Supplements",
      "Skincare",
      "Personal care",
      "Cleaning products"
    ]
  },
  {
    "name": "Cetyl Alcohol",
    "aliases": [],
    "status": "allowed",
    "description": "A fatty alcohol (not drying ethanol) that supports skin barrier function and product stability.",
    "foundIn": [
      "Skincare",
      "Personal care"
    ]
  },
  {
    "name": "Cetearyl Olivate",
    "aliases": [],
    "status": "allowed",
    "description": "A naturally derived emulsifier from olive oil that helps mimic the skin's lipid structure, improving moisture retention and product stability.",
    "foundIn": [
      "Skincare"
    ]
  },
  {
    "name": "Chemical Sunscreens",
    "aliases": [
      "Oxybenzone",
      "Octinoxate",
      "Homosalate"
    ],
    "status": "banned",
    "description": "Hormone disruption, coral bleaching, and systemic absorption.",
    "statusNote": "Mineral SPF allowed only",
    "foundIn": [
      "Skincare (SPF products)",
      "Personal care (lip balms with SPF)"
    ]
  },
  {
    "name": "Canola Oil (Non-Organic / Refined)",
    "aliases": [
      "Refined Canola Oil"
    ],
    "status": "banned",
    "description": "Highly refined canola oil is prone to oxidation, often solvent-extracted, and high in omega-6 fatty acids that can contribute to chronic inflammation when consumed regularly. Non-organic canola is also commonly contaminated with glyphosate residues.",
    "statusNote": "Banned in supplements",
    "foundIn": [
      "Supplements"
    ]
  },
  {
    "name": "Citral",
    "aliases": [],
    "status": "allowed",
    "description": "A naturally occurring compound found in citrus and lemongrass oils. Used as part of botanical fragrance systems and contributes to a clean, citrus scent.",
    "foundIn": [
      "Skincare",
      "Personal care",
      "Cleaning products"
    ]
  },
  {
    "name": "Carrageenan",
    "aliases": [],
    "status": "banned",
    "description": "Gut irritation, bloating, increased intestinal permeability in sensitive individuals.",
    "statusNote": "Banned in ingestibles",
    "foundIn": [
      "Supplements (capsules, liquids, powders)"
    ]
  },
  {
    "name": "Cocamidopropyl Betaine",
    "aliases": [],
    "status": "banned",
    "description": "A synthetic surfactant used to create foam and reduce irritation in cleansing products. While commonly used, it is associated with contamination concerns and skin sensitization in some individuals.",
    "foundIn": [
      "Personal care (shampoos, body washes)",
      "Cleaning products"
    ]
  },
  {
    "name": "Cucumis Sativus (Cucumber) Extract",
    "aliases": [
      "Cucumber Extract"
    ],
    "status": "allowed",
    "description": "A whole-plant cucumber extract rich in antioxidants and soothing compounds. Supports hydration and skin comfort.",
    "foundIn": [
      "Skincare"
    ]
  },
  {
    "name": "Cyclic Silicones",
    "aliases": [
      "D4",
      "D5",
      "D6",
      "Cyclomethicone",
      "Cyclopentasiloxane"
    ],
    "status": "banned",
    "description": "Reproductive toxicity, endocrine disruption, environmental persistence.",
    "foundIn": [
      "Skincare (serums, primers)",
      "Personal care (hair products)"
    ]
  },
  {
    "name": "Decyl Polyglucoside",
    "aliases": [
      "Sugar Surfactant"
    ],
    "status": "allowed",
    "description": "A gentle, biodegradable surfactant derived from plant sugars and fatty alcohols. Effectively cleans without stripping the skin barrier.",
    "foundIn": [
      "Skincare",
      "Personal care",
      "Cleaning products"
    ]
  },
  {
    "name": "Distearoylethyl Dimonium Chloride",
    "aliases": [],
    "status": "allowed",
    "description": "A conditioning agent used in hair care to reduce static, improve softness, and enhance manageability. It binds selectively to damaged areas of the hair shaft, helping smooth and protect hair without functioning as a preservative or antimicrobial.",
    "foundIn": [
      "Personal care (hair conditioners, treatments)"
    ]
  },
  {
    "name": "Diethylhexyl Maleate",
    "aliases": [],
    "status": "allowed",
    "description": "A conditioning agent that helps protect hair bonds during chemical treatments without known endocrine disruption concerns.",
    "foundIn": [
      "Personal care (hair products)"
    ]
  },
  {
    "name": "Diheptyl Succinate",
    "aliases": [],
    "status": "allowed",
    "description": "A lightweight, biodegradable emollient that provides a silky feel without clogging pores. Often used as a natural silicone alternative.",
    "foundIn": [
      "Skincare",
      "Personal care"
    ]
  },
  {
    "name": "Disodium Cocoamphodiacetate",
    "aliases": [],
    "status": "allowed",
    "description": "A mild amphoteric surfactant suitable for sensitive skin and scalp.",
    "foundIn": [
      "Personal care",
      "Skincare"
    ]
  },
  {
    "name": "Disodium 2-Sulfolaurate",
    "aliases": [],
    "status": "allowed",
    "description": "A gentle, biodegradable surfactant with low irritation potential.",
    "foundIn": [
      "Personal care",
      "Cleaning products"
    ]
  },
  {
    "name": "EDTA",
    "aliases": [
      "Tetrasodium EDTA",
      "Disodium EDTA"
    ],
    "status": "banned",
    "description": "Poorly biodegradable; binds metals in waterways and disrupts aquatic ecosystems.",
    "foundIn": [
      "Skincare",
      "Personal care",
      "Cleaning products"
    ]
  },
  {
    "name": "Essential Oils",
    "aliases": [],
    "status": "conditional",
    "description": "When properly sourced and used at appropriate dilutions, essential oils can provide functional benefits and natural fragrance. Essential oils are potent and not automatically \"better.\" We prioritize quality, dilution, and transparency over blanket use.",
    "foundIn": [
      "Skincare",
      "Personal care",
      "Cleaning products"
    ]
  },
  {
    "name": "Ethanolamines",
    "aliases": [
      "DEA",
      "MEA",
      "TEA",
      "Diethanolamine",
      "Triethanolamine"
    ],
    "status": "banned",
    "description": "Can form carcinogenic nitrosamines.",
    "foundIn": [
      "Skincare",
      "Personal care",
      "Cleaning products"
    ]
  },
  {
    "name": "Ethoxylated Ingredients",
    "aliases": [
      "PEGs",
      "Polysorbates",
      "Ceteareth-20",
      "-eth ingredients"
    ],
    "status": "banned",
    "description": "Risk of contamination with 1,4-dioxane and ethylene oxide.",
    "foundIn": [
      "Skincare",
      "Personal care",
      "Cleaning products",
      "Supplements (capsules, flavor systems)"
    ]
  },
  {
    "name": "Ethylhexylglycerin",
    "aliases": [],
    "status": "allowed",
    "description": "A multifunctional ingredient used to support preservation systems and skin conditioning. Well-tolerated at low concentrations.",
    "foundIn": [
      "Skincare",
      "Personal care"
    ]
  },
  {
    "name": "Natural Flavors",
    "aliases": [
      "Flavor Systems",
      "Flavoring"
    ],
    "status": "conditional",
    "description": "Often include hundreds of hidden ingredients.",
    "nuance": "Transparency required — we evaluate based on full ingredient disclosure.",
    "statusNote": "Transparency required",
    "foundIn": [
      "Supplements",
      "Personal care (toothpaste)"
    ]
  },
  {
    "name": "Fluoride",
    "aliases": [
      "Sodium Fluoride",
      "Stannous Fluoride"
    ],
    "status": "banned",
    "description": "Fluoride is a biologically active compound used to reduce tooth decay, but it is also classified as a neurotoxicant at sufficient levels of exposure. Research has raised concerns about fluoride's ability to cross the blood–brain barrier, accumulate in the body, and potentially interfere with neurological development, particularly with chronic exposure during pregnancy and early childhood. Because fluoride is not an essential nutrient and alternatives exist that support enamel health without systemic exposure, we choose a precautionary approach.",
    "foundIn": [
      "Personal care (toothpaste, mouthwash)"
    ]
  },
  {
    "name": "Fragrance",
    "aliases": [
      "Parfum",
      "Synthetic Fragrance"
    ],
    "status": "conditional",
    "description": "\"Fragrance\" can represent dozens to hundreds of aroma chemicals, including endocrine disruptors. We don't treat fragrance as one monolithic \"bad.\" We treat it as a transparency issue and a sensitivity issue. Fragrance is one of the most common triggers for irritation and can hide undisclosed chemicals when brands use the catch-all term \"fragrance/parfum.\"",
    "nuance": "Every scented product must disclose its fragrance category (fragrance-free / essential oils / botanical isolates / safe synthetic aromatics). We incentivize full disclosure of fragrance ingredients and do not accept \"trade secret\" blends for products marketed as clean. We prohibit phthalates, nitromusks, and polycyclic musks in any fragrance system.",
    "statusNote": "Allowed only with full disclosure",
    "foundIn": [
      "Skincare",
      "Personal care",
      "Cleaning products"
    ]
  },
  {
    "name": "Formaldehyde + Formaldehyde-Releasers",
    "aliases": [
      "DMDM Hydantoin",
      "Diazolidinyl Urea",
      "Quaternium-15"
    ],
    "status": "banned",
    "description": "Allergic reactions, respiratory issues, cancer risk.",
    "foundIn": [
      "Skincare",
      "Personal care",
      "Cleaning products"
    ]
  },
  {
    "name": "Geraniol",
    "aliases": [],
    "status": "allowed",
    "description": "A naturally occurring aromatic compound found in many essential oils. It contributes to scent and is commonly present as a constituent of botanical fragrance systems.",
    "foundIn": [
      "Skincare",
      "Personal care",
      "Cleaning products"
    ]
  },
  {
    "name": "Glyceryl Stearate SE",
    "aliases": [],
    "status": "allowed",
    "description": "A plant-derived emulsifier that helps blend oil and water while supporting skin barrier function.",
    "foundIn": [
      "Skincare",
      "Personal care"
    ]
  },
  {
    "name": "Glycereth",
    "aliases": [
      "Ethoxylated Glycerin",
      "Glycereth-7",
      "Glycereth-26"
    ],
    "status": "banned",
    "description": "Glycereth ingredients are ethoxylated compounds, meaning they are processed using ethylene oxide and may be contaminated with 1,4-dioxane, a known carcinogen. While glycerin itself is safe, glycereth derivatives introduce unnecessary contamination risk.",
    "foundIn": [
      "Skincare (lotions, serums)",
      "Personal care (hair products, cleansers)"
    ]
  },
  {
    "name": "Glyphosate",
    "aliases": [],
    "status": "conditional",
    "description": "A widely used herbicide associated with gut microbiome disruption, oxidative stress, endocrine interference, and possible carcinogenicity. Glyphosate residues are commonly found in conventionally grown crops and can appear in supplements made from non-organic plant ingredients.",
    "statusNote": "Transparent via COA",
    "foundIn": [
      "Supplements (botanicals, grains, proteins)",
      "Cleaning products (herbicide residues via raw materials)"
    ]
  },
  {
    "name": "Guar Gum",
    "aliases": [],
    "status": "conditional",
    "description": "Guar gum is a plant-derived polysaccharide used as a thickener and stabilizer. It can improve texture and consistency in both topical and ingestible products. Derived from the guar bean (Cyamopsis tetragonoloba), a legume primarily grown in India and Pakistan.",
    "nuance": "In higher amounts, guar gum can ferment in the gut and may cause bloating or discomfort in sensitive individuals (especially those with IBS or SIBO). For this reason, we prefer minimal use and clear labeling in supplements.",
    "foundIn": [
      "Supplements",
      "Personal care"
    ]
  },
  {
    "name": "Guar Hydroxypropyltrimonium Chloride",
    "aliases": [],
    "status": "allowed",
    "description": "A plant-derived conditioning polymer made from guar gum that helps improve slip, softness, and manageability of hair. It reduces static and enhances combability without heavy buildup.",
    "foundIn": [
      "Personal care (hair conditioners, shampoos)"
    ]
  },
  {
    "name": "Heavy Metals",
    "aliases": [
      "Lead",
      "Arsenic",
      "Cadmium",
      "Mercury"
    ],
    "status": "conditional",
    "description": "Heavy metals are naturally occurring. They most often appear as trace impurities from naturally derived minerals (clays, pigments like iron oxides), botanicals, and soil.",
    "nuance": "\"Prop 65 warning = unsafe\" is not how we evaluate products. Proposition 65 is a bounty hunter law and a warning can appear when a company can't (or won't) prove exposures are below California's thresholds. We require COAs and/or batch testing for relevant products. We prioritize \"as low as reasonably achievable,\" especially in supplements. We do not accept Prop 65 warnings as a proxy for safety; we accept data.",
    "statusNote": "Monitored via COA",
    "foundIn": [
      "Supplements",
      "Skincare (mineral pigments)",
      "Personal care"
    ]
  },
  {
    "name": "Hypromellose",
    "aliases": [
      "Hydroxypropyl Methylcellulose",
      "HPMC"
    ],
    "status": "allowed",
    "description": "A plant-derived cellulose used to create vegetarian capsules. It is chemically inert, non-digestible, and provides structure and controlled dissolution for supplements without interacting with the active ingredients.",
    "foundIn": [
      "Supplements (vegetarian capsules)"
    ]
  },
  {
    "name": "High Fructose Corn Syrup",
    "aliases": [
      "HFCS"
    ],
    "status": "banned",
    "description": "HFCS contributes to blood sugar dysregulation, insulin resistance, fatty liver, and increased inflammation. It offers no benefit in supplements and is often used to mask poor formulation quality.",
    "foundIn": [
      "Supplements"
    ]
  },
  {
    "name": "Hexylene Glycol",
    "aliases": [],
    "status": "allowed",
    "description": "A low-volatility solvent and texture enhancer used to help dissolve ingredients and improve product stability. At appropriate concentrations, it supports even formulation without acting as a preservative or fragrance.",
    "foundIn": [
      "Skincare",
      "Personal care",
      "Cleaning products"
    ]
  },
  {
    "name": "Hyaluronic Acid",
    "aliases": [
      "Sodium Hyaluronate"
    ],
    "status": "allowed",
    "description": "A naturally occurring molecule found in skin and connective tissue that binds water and supports hydration, elasticity, and skin comfort.",
    "foundIn": [
      "Skincare",
      "Personal care"
    ]
  },
  {
    "name": "Hydroquinone",
    "aliases": [],
    "status": "banned",
    "description": "Benzene metabolite; skin irritation and carcinogenic concerns.",
    "foundIn": [
      "Skincare (skin-lightening products)"
    ]
  },
  {
    "name": "Hydroxyacetophenone",
    "aliases": [],
    "status": "allowed",
    "description": "A multifunctional antioxidant and preservative booster that allows for gentler preservation systems without formaldehyde releasers.",
    "foundIn": [
      "Skincare",
      "Personal care"
    ]
  },
  {
    "name": "Hydrolyzed Jojoba Esters",
    "aliases": [],
    "status": "allowed",
    "description": "Jojoba-derived wax esters that enhance skin softness and barrier support without greasiness.",
    "foundIn": [
      "Skincare",
      "Personal care"
    ]
  },
  {
    "name": "Hydroxyapatite (Non-Nano)",
    "aliases": [
      "nHAp",
      "Hydroxyapatite"
    ],
    "status": "conditional",
    "description": "A naturally occurring mineral that makes up human teeth and bones. In oral care, hydroxyapatite supports enamel remineralization. Claims that hydroxyapatite is toxic are not supported by credible human data.",
    "nuance": "We require non-nano forms and transparent sourcing.",
    "foundIn": [
      "Personal care (toothpaste)"
    ]
  },
  {
    "name": "Isoamyl Laurate",
    "aliases": [],
    "status": "allowed",
    "description": "A plant-derived emollient used to improve texture and spreadability. Often used as a natural alternative to silicones, it provides a smooth, dry-touch feel without creating buildup on the skin or hair.",
    "foundIn": [
      "Skincare",
      "Personal care"
    ]
  },
  {
    "name": "Kombucha Ferment",
    "aliases": [
      "Saccharomyces / Xylinum / Black Tea Ferment"
    ],
    "status": "allowed",
    "description": "A fermented black tea extract rich in organic acids and antioxidants. Supports skin vitality and barrier health.",
    "foundIn": [
      "Skincare"
    ]
  },
  {
    "name": "Lactobacillus / Yerba Santa Ferment",
    "aliases": [
      "Eriodictyon Californicum Ferment"
    ],
    "status": "allowed",
    "description": "A probiotic ferment combined with a traditionally soothing botanical. Supports skin microbiome balance and calming effects.",
    "foundIn": [
      "Skincare"
    ]
  },
  {
    "name": "Laureth-2",
    "aliases": [],
    "status": "banned",
    "description": "A polyethylene glycol (PEG)-derived surfactant that is ethoxylated, making it susceptible to contamination with ethylene oxide and 1,4-dioxane. Also known to be irritating to sensitive skin.",
    "foundIn": [
      "Skincare (cleansers)",
      "Personal care (shampoos, body washes)",
      "Cleaning products"
    ]
  },
  {
    "name": "Limonene",
    "aliases": [],
    "status": "allowed",
    "description": "A citrus-derived aromatic compound commonly found in essential oils. Provides a fresh scent profile and is naturally present in many botanical extracts.",
    "foundIn": [
      "Skincare",
      "Personal care",
      "Cleaning products"
    ]
  },
  {
    "name": "Linalool",
    "aliases": [],
    "status": "allowed",
    "description": "A naturally occurring fragrance component found in essential oils such as lavender and citrus. Used to provide scent and aromatic balance in formulations.",
    "foundIn": [
      "Skincare",
      "Personal care",
      "Cleaning products"
    ]
  },
  {
    "name": "Malic Acid",
    "aliases": [],
    "status": "allowed",
    "description": "A naturally occurring organic acid involved in cellular energy production (Krebs cycle). Supports flavor balance and mineral absorption.",
    "foundIn": [
      "Supplements",
      "Skincare"
    ]
  },
  {
    "name": "Maltodextrin",
    "aliases": [],
    "status": "conditional",
    "description": "Maltodextrin is a carbohydrate derived from starch (commonly corn, rice, or tapioca) used in small amounts as a carrier or stabilizer in powders and extracts. It helps evenly distribute concentrated ingredients and improve product stability in certain formulations.",
    "nuance": "Maltodextrin is often criticized because it has a high glycemic index and is commonly used as a cheap filler in ultra-processed foods and low-quality supplements. At Live Healthillie, we do not allow it as a filler. We only permit maltodextrin when it is organic, minimally processed, and used intentionally as a functional carrier (for example, to stabilize probiotics or botanical extracts where a carrier is necessary for ingredient integrity).",
    "statusNote": "Allowed organic & purpose-driven only",
    "foundIn": [
      "Supplements (powders, probiotic blends, botanical extracts)"
    ]
  },
  {
    "name": "Methyl Cellosolve",
    "aliases": [
      "2-Methoxyethanol",
      "Ethylene Glycol Monomethyl Ether"
    ],
    "status": "banned",
    "description": "A solvent sometimes used in fragrance/perfume applications and industrial formulations. 2-Methoxyethanol is classified in Europe as toxic to reproduction (a key reason it's heavily restricted/treated as not appropriate for cosmetics). It can irritate skin and at sufficient exposures may affect the nervous system and blood-forming tissues.",
    "foundIn": [
      "Skincare",
      "Personal care (fragrance)"
    ]
  },
  {
    "name": "Methylisothiazolinone",
    "aliases": [
      "MI",
      "MCI",
      "Methylchloroisothiazolinone"
    ],
    "status": "banned",
    "description": "Preservatives used to prevent microbial growth, especially in water-based products. MI and MCI are well-known causes of contact allergy and skin sensitization. The EU moved to prohibit MI in leave-on products and restrict use due to rising allergy incidence and lack of a safe level for leave-on exposure.",
    "foundIn": [
      "Skincare",
      "Personal care",
      "Cleaning products"
    ]
  },
  {
    "name": "Mica",
    "aliases": [],
    "status": "conditional",
    "description": "A naturally occurring mineral used for shimmer and pigmentation in cosmetics. The primary concern is human-rights related: high risk of child labor and poor working conditions in mining.",
    "statusNote": "Allowed only if ethically sourced",
    "foundIn": [
      "Skincare (makeup)",
      "Personal care"
    ]
  },
  {
    "name": "Mineral Oil, Paraffin, Petrolatum",
    "aliases": [
      "Paraffin",
      "Petrolatum",
      "Petroleum Jelly"
    ],
    "status": "banned",
    "description": "Often contaminated with PAHs (polyaromatic hydrocarbons), which are linked to cancer. Also environmentally harmful and unnecessary given safer alternatives.",
    "foundIn": [
      "Skincare",
      "Personal care",
      "Cleaning products"
    ]
  },
  {
    "name": "Monk Fruit",
    "aliases": [
      "Luo Han Guo"
    ],
    "status": "allowed",
    "description": "A non-glycemic, plant-based sweetener with no known gut-disruptive effects when used without erythritol fillers. We avoid monk fruit blends bulked with sugar alcohols.",
    "foundIn": [
      "Supplements"
    ]
  },
  {
    "name": "Myrcene",
    "aliases": [],
    "status": "allowed",
    "description": "A naturally occurring terpene found in plants such as hops, bay, and citrus. It contributes to scent and is present in essential oil–based formulations.",
    "foundIn": [
      "Skincare",
      "Personal care",
      "Cleaning products"
    ]
  },
  {
    "name": "Oleyl Alcohol",
    "aliases": [],
    "status": "allowed",
    "description": "A fatty alcohol derived from plant oils that acts as an emollient and penetration enhancer without barrier damage.",
    "foundIn": [
      "Skincare",
      "Personal care"
    ]
  },
  {
    "name": "Panthenol",
    "aliases": [
      "Pro-Vitamin B5",
      "Provitamin B5"
    ],
    "status": "allowed",
    "description": "A vitamin-derived ingredient that supports hydration, elasticity, and barrier function. Panthenol helps attract moisture to the skin and hair while improving softness and resilience.",
    "foundIn": [
      "Skincare",
      "Personal care (hair and scalp products)"
    ]
  },
  {
    "name": "Parabens",
    "aliases": [
      "Methylparaben",
      "Ethylparaben",
      "Propylparaben"
    ],
    "status": "banned",
    "description": "Strong evidence of endocrine disruption and estrogenic effects. Found in breast tissue and linked to reproductive toxicity.",
    "foundIn": [
      "Skincare",
      "Personal care",
      "Cleaning products"
    ]
  },
  {
    "name": "Polyethylene Glycol",
    "aliases": [
      "PEG",
      "PEGs"
    ],
    "status": "banned",
    "description": "PEGs are petroleum-derived, ethoxylated compounds that can be contaminated with carcinogenic byproducts and increase skin permeability, allowing other chemicals to penetrate more deeply. In supplements, PEGs are unnecessary excipients that add no nutritional value.",
    "foundIn": [
      "Skincare",
      "Personal care",
      "Cleaning products",
      "Supplements (capsules, coatings, flavor systems)"
    ]
  },
  {
    "name": "Propanediol",
    "aliases": [
      "1,3-Propanediol"
    ],
    "status": "allowed",
    "description": "A plant-derived alternative to propylene glycol with a better tolerability profile and lower irritation risk.",
    "foundIn": [
      "Skincare",
      "Personal care",
      "Supplements"
    ]
  },
  {
    "name": "Phenylalanine",
    "aliases": [],
    "status": "allowed",
    "description": "An essential amino acid involved in protein synthesis and skin conditioning. Supports normal cellular function.",
    "foundIn": [
      "Skincare",
      "Supplements"
    ]
  },
  {
    "name": "Phenoxyethanol",
    "aliases": [],
    "status": "banned",
    "description": "Associated with skin irritation and infant toxicity concerns.",
    "foundIn": [
      "Skincare",
      "Personal care",
      "Cleaning products"
    ]
  },
  {
    "name": "Phthalates",
    "aliases": [
      "DEP",
      "DBP",
      "DEHP"
    ],
    "status": "banned",
    "description": "Potent endocrine disruptors affecting male fertility, fetal development, and hormone balance. Often hidden in fragrance.",
    "foundIn": [
      "Skincare",
      "Personal care",
      "Cleaning products (fragrance)"
    ]
  },
  {
    "name": "Propylene Glycol",
    "aliases": [
      "PG"
    ],
    "status": "banned",
    "description": "Propylene glycol is a synthetic solvent and humectant that can irritate sensitive skin and the gut and offers little benefit in wellness-focused formulations when alternatives exist. Used commonly as an antifoaming agent in protein powders.",
    "statusNote": "Banned in supplements",
    "foundIn": [
      "Supplements (protein powders, flavored blends, liquid supplements)"
    ]
  },
  {
    "name": "Quaternary Ammonium Compounds",
    "aliases": [
      "Quats"
    ],
    "status": "banned",
    "description": "A broad class used as antimicrobials in disinfectants and as conditioning/anti-static agents in personal care. Quats can be effective antimicrobials, but in personal care they can contribute to irritation and are not our first-choice preservative strategy when safer systems exist.",
    "foundIn": [
      "Cleaning products",
      "Personal care (hair products)"
    ]
  },
  {
    "name": "Resorcinol",
    "aliases": [],
    "status": "banned",
    "description": "Commonly used in oxidative hair dyes (and some specialty applications). Resorcinol has evidence suggesting endocrine-related concerns (especially around thyroid pathways), and it's also associated with irritation/allergy in some users. The EU's SCCS has evaluated resorcinol and set concentration limits for hair dye uses, reflecting that it's an ingredient regulators actively monitor and constrain rather than \"no concern.\"",
    "foundIn": [
      "Personal care (hair dyes)"
    ]
  },
  {
    "name": "Saccharin",
    "aliases": [],
    "status": "banned",
    "description": "Saccharin is one of the oldest synthetic sweeteners and has been shown in both animal and human research to alter gut microbiota composition and affect glucose tolerance in certain individuals. It can also produce a bitter aftertaste that often requires masking agents.",
    "foundIn": [
      "Supplements (tablets, flavored powders)",
      "Personal care (toothpaste, mouth rinses)"
    ]
  },
  {
    "name": "Silicon Dioxide",
    "aliases": [
      "Silica"
    ],
    "status": "banned",
    "description": "Often used as a filler without purpose; can be contaminated with nanoparticles; unnecessary in most high-quality formulations.",
    "statusNote": "Banned in supplements",
    "foundIn": [
      "Supplements (capsules, powders)"
    ]
  },
  {
    "name": "SLS / SLES",
    "aliases": [
      "Sodium Lauryl Sulfate",
      "Sodium Laureth Sulfate"
    ],
    "status": "banned",
    "description": "Skin barrier disruption, irritation, and contamination risk (1,4-dioxane).",
    "foundIn": [
      "Personal care",
      "Cleaning products"
    ]
  },
  {
    "name": "Sodium Citrate",
    "aliases": [],
    "status": "allowed",
    "description": "A citric acid salt used to buffer pH and stabilize formulations. Well tolerated and non-irritating.",
    "foundIn": [
      "Skincare",
      "Personal care",
      "Cleaning products"
    ]
  },
  {
    "name": "Sodium Cocoyl Isethionate",
    "aliases": [
      "SCI"
    ],
    "status": "allowed",
    "description": "A mild, coconut-derived surfactant that cleans effectively without stripping the skin barrier.",
    "foundIn": [
      "Personal care",
      "Skincare"
    ]
  },
  {
    "name": "Sodium Lactate",
    "aliases": [],
    "status": "allowed",
    "description": "A naturally occurring component of the skin's natural moisturizing factor (NMF). Helps regulate pH and improve hydration.",
    "foundIn": [
      "Skincare",
      "Personal care"
    ]
  },
  {
    "name": "Sodium PCA",
    "aliases": [],
    "status": "allowed",
    "description": "A naturally occurring molecule found in the skin's Natural Moisturizing Factor (NMF). It attracts and holds water in the skin, supporting hydration and maintaining skin comfort.",
    "foundIn": [
      "Skincare",
      "Personal care"
    ]
  },
  {
    "name": "Sorbeth-30",
    "aliases": [],
    "status": "banned",
    "description": "An ethoxylated surfactant used to solubilize fragrance and oils. Like other \"-eth\" ingredients, it carries risk of 1,4-dioxane contamination and offers no health-forward benefit when cleaner solubilizers exist.",
    "foundIn": [
      "Skincare (cleansers, micellar waters)",
      "Personal care (fragranced products)"
    ]
  },
  {
    "name": "Sorbitan Oleate Decylglucoside Crosspolymer",
    "aliases": [],
    "status": "allowed",
    "description": "A mild, biodegradable surfactant system derived from plant sugars and fatty acids. It provides gentle cleansing and stabilization while maintaining the integrity of the skin barrier, making it suitable for sensitive-skin formulations.",
    "foundIn": [
      "Skincare",
      "Personal care",
      "Cleaning products"
    ]
  },
  {
    "name": "Sorbitan Olivate",
    "aliases": [],
    "status": "allowed",
    "description": "An olive-derived emulsifier that works synergistically with cetearyl olivate to support barrier function and gentle formulation.",
    "foundIn": [
      "Skincare"
    ]
  },
  {
    "name": "Soy Lecithin",
    "aliases": [],
    "status": "conditional",
    "description": "Soy lecithin is a natural source of phospholipids, including phosphatidylcholine, which are essential components of human cell membranes and play key roles in liver function, bile flow, and neurological health. Most conventional soy lecithin is derived from GMO soy, chemically processed, and used as a low-cost emulsifier, raising concerns around glyphosate residues and lack of therapeutic intent.",
    "nuance": "When soy lecithin is identity-preserved, non-GMO, solvent-free, and standardized for phospholipid content, it can be biologically beneficial and functionally necessary — particularly in targeted phosphatidylcholine and membrane-support supplements. Not allowed as a generic filler or emulsifier; allowed when cleanly sourced and used intentionally for therapeutic phospholipid delivery.",
    "statusNote": "Source-dependent",
    "foundIn": [
      "Supplements"
    ]
  },
  {
    "name": "Stearic Acid",
    "aliases": [],
    "status": "allowed",
    "description": "A naturally occurring fatty acid found in plants and the skin's lipid barrier. Supports emulsification and skin softness.",
    "foundIn": [
      "Skincare",
      "Personal care"
    ]
  },
  {
    "name": "Stearyl Alcohol",
    "aliases": [],
    "status": "allowed",
    "description": "A fatty alcohol derived from plant oils that helps thicken formulations and support the skin barrier. Unlike drying alcohols, stearyl alcohol contributes to moisture retention and product stability.",
    "foundIn": [
      "Skincare",
      "Personal care"
    ]
  },
  {
    "name": "Steartrimonium / Stearamidopropyl Dimethylamine",
    "aliases": [],
    "status": "allowed",
    "description": "A conditioning agent used in hair care to reduce static and improve manageability. Used at low levels and rinsed off.",
    "foundIn": [
      "Personal care (hair products)"
    ]
  },
  {
    "name": "Stevia",
    "aliases": [
      "Steviol Glycosides",
      "Stevia Leaf"
    ],
    "status": "allowed",
    "description": "Stevia leaf is a plant-derived sweetener that does not raise blood sugar and does not feed gut pathogens when used appropriately. Whole-leaf or minimally processed extracts differ significantly from highly refined steviol glycosides used in ultra-processed foods.",
    "foundIn": [
      "Supplements (powders, electrolyte blends)"
    ]
  },
  {
    "name": "Sucralose",
    "aliases": [
      "Splenda"
    ],
    "status": "banned",
    "description": "Linked to gut dysbiosis, suppressed beneficial microbes, glucose intolerance, and increased cravings.",
    "foundIn": [
      "Supplements"
    ]
  },
  {
    "name": "Sunflower Lecithin",
    "aliases": [],
    "status": "allowed",
    "description": "A phospholipid-rich emulsifier that supports fat digestion and nutrient absorption. Sunflower lecithin is naturally free from soy allergens and is typically non-GMO.",
    "foundIn": [
      "Supplements (capsules, powders)",
      "Skincare"
    ]
  },
  {
    "name": "Sunflower Oil",
    "aliases": [
      "Helianthus Annuus Oil"
    ],
    "status": "allowed",
    "description": "A stable, vitamin-E-rich oil that supports the skin barrier and is low in irritation risk. Our allowance applies to topical use; dietary oils are evaluated differently depending on sourcing, quality, purpose and amount.",
    "foundIn": [
      "Skincare",
      "Personal care"
    ]
  },
  {
    "name": "Squalane (Olive-Derived)",
    "aliases": [
      "Olive Squalane"
    ],
    "status": "allowed",
    "description": "A lightweight, stable lipid derived from olives that closely mimics components of the skin's natural sebum. It helps support hydration, improve barrier function, and soften the skin without clogging pores or causing irritation.",
    "foundIn": [
      "Skincare",
      "Personal care"
    ]
  },
  {
    "name": "Talc",
    "aliases": [],
    "status": "banned",
    "description": "Risk of asbestos contamination and inhalation concerns.",
    "foundIn": [
      "Skincare (makeup)",
      "Personal care"
    ]
  },
  {
    "name": "Titanium Dioxide",
    "aliases": [
      "TiO2"
    ],
    "status": "conditional",
    "description": "Titanium dioxide is a mineral pigment commonly used for whitening and opacity. While it can be safe when used topically (non-inhalable, non-nano, properly formulated), concerns arise with ingestion and inhalation. When consumed, titanium dioxide particles may contribute to intestinal inflammation, oxidative stress, and potential disruption of gut barrier integrity, which is why several regulatory bodies have taken a precautionary stance on its use in foods and supplements.",
    "nuance": "This is not a blanket ban on titanium dioxide as a mineral. Context matters. We evaluate the route of exposure and form. Not allowed in ingestibles (supplements, capsules, powders, gummies). Not allowed in inhalable products. Allowed topically.",
    "statusNote": "Topical only",
    "foundIn": [
      "Supplements",
      "Personal care (toothpaste)",
      "Skincare (makeup, sunscreens)"
    ]
  },
  {
    "name": "Tocopheryl Acetate",
    "aliases": [
      "Vitamin E Acetate",
      "Tocopherol"
    ],
    "status": "allowed",
    "description": "A stable form of vitamin E used for antioxidant support and product stability.",
    "foundIn": [
      "Skincare",
      "Personal care"
    ]
  },
  {
    "name": "Toluene",
    "aliases": [],
    "status": "banned",
    "description": "A solvent historically used in nail products and industrial coatings. At high exposures, toluene can affect the nervous system and has been associated with developmental harm in pregnancy (the strongest data are from high-dose exposures). It remains a chemical we consider unnecessary in clean personal care.",
    "foundIn": [
      "Personal care (nail products)"
    ]
  },
  {
    "name": "Triclosan & Triclocarban",
    "aliases": [
      "Triclosan",
      "Triclocarban"
    ],
    "status": "banned",
    "description": "Hormone disruption, bacterial resistance, and environmental damage.",
    "foundIn": [
      "Personal care (toothpaste, soaps)"
    ]
  },
  {
    "name": "Vegetable Glycerin",
    "aliases": [
      "Glycerin",
      "Glycerol"
    ],
    "status": "allowed",
    "description": "A plant-derived humectant that draws moisture into the skin and supports hydration. Well tolerated and widely studied.",
    "foundIn": [
      "Skincare",
      "Personal care",
      "Cleaning products"
    ]
  },
  {
    "name": "Xanthan Gum (Non-GMO)",
    "aliases": [
      "Xanthan Gum"
    ],
    "status": "conditional",
    "description": "Xanthan gum is a fermentation-derived polysaccharide used to stabilize and thicken formulations. It has a long history of safe use when sourced and used appropriately. Produced through fermentation of carbohydrates (such as glucose or sucrose) by the bacterium Xanthomonas campestris.",
    "nuance": "While generally well tolerated, excessive use or stacking with other gums can contribute to bloating or GI discomfort in sensitive individuals. We evaluate use levels and formulation context. We require non-GMO fermentation substrates.",
    "statusNote": "Non-GMO required",
    "foundIn": [
      "Supplements",
      "Personal care"
    ]
  }
];
